import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { SatisfactionConfigService } from 'src/app/services/satisfaction-services/satisfaction-config-service/satisfaction-config.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';

@Component({
  selector: 'app-satisfaction-config-dashboard',
  templateUrl: './satisfaction-config-dashboard.component.html',
  styleUrls: ['./satisfaction-config-dashboard.component.scss']
})
export class SatisfactionConfigDashboardComponent implements OnInit, OnDestroy {

  config;
  listenGetSatisfactionConfigubscription: Subscription;
  getSatisfactionConfigubscription: Subscription;

  constructor(private satisfactionConfigService: SatisfactionConfigService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.listenSatisfactionConfig();
    this.setBreadcrumb();
    this.getSatisfactionConfig();
  }

  private listenSatisfactionConfig() {
    this.listenGetSatisfactionConfigubscription = this.satisfactionConfigService.listenGetSatisfactionConfig().pipe(
      tap(o => this.getSatisfactionConfig()),
    ).subscribe();
  }

  private getSatisfactionConfig() {
    this.getSatisfactionConfigubscription = this.satisfactionConfigService.getSatisfactionConfig().pipe(
      tap(o => this.config = o),
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-star-half-alt', 'satisfactions-page.config', '/satisfaction', [new BRoute('satisfactions-page.satisfaction', '/satisfaction'), new BRoute('satisfactions-page.config')]));
  }

  ngOnDestroy () {
    if (this.listenGetSatisfactionConfigubscription) { this.listenGetSatisfactionConfigubscription.unsubscribe(); }
    if (this.getSatisfactionConfigubscription) { this.getSatisfactionConfigubscription.unsubscribe(); }
  }
}
